import { AppThunk } from '../../../store/rootReducer';
import * as authActions from '../actions/auth.actions';
import * as organizationClient from '../clients/organization.client';
import { User } from '../types/auth';

export const loadCoworkers =
  (user: User): AppThunk =>
  async (dispatch) => {
    if (user.organization == null) {
      return;
    }

    const coworkers = await organizationClient.getCoworkers(
      user.organization.id,
    );

    if (coworkers == null) {
      return;
    }

    dispatch(authActions.setCoworkers({ coworkers, meta: { history: false } }));
  };
